
const digest = '6d6493ab0393c07ca1fbb0daf012e86fde1d93b9315c09201c7cbb7151230374';
const classes = {"image":"_image_1u448_1"};
const css = `._image_1u448_1 {
  object-fit: contain;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  